// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__5HpPJ","file":"styles_file__rHN7u"};